import { configureStore } from "@reduxjs/toolkit";
import reducer from "../api/xoicom.reducer";

export const store = configureStore({
  reducer: { reducer },
});
